<template>
<div class="HuongDanGuiHang">
    <div class="yamato">
        <div class="thong-tin col-md-12" >
       <h3>Cách gửi hàng Yamato</h3>
     </div>
        <img :src="huongDanYamato" style="width: 70%"/>
    </div>
    <div class="japanpost">
        <div class="thong-tin col-md-12" >
       <h3>Cách gửi hàng Bưu điện (JapanPost)</h3>
     </div>
        <img :src="huongDanBuuDien" style="width: 70%"/>
    </div>
    <div class="thong-tin col-md-12" >
       <h3>Liên hệ</h3>
     </div>
    <div class="col-md-12 thong-tin-lien-he"  style="margin-bottom:4em">
      <h4 style="color: blue;white-space:pre-line">FanPage Vận chuyển: <a href="https://www.facebook.com/pg/vanchuyenmaiphuong" target="blank"> Page Công ty vận chuyển >> click</a> </h4>
      <h4 style="color: blue;white-space:pre-line">FanPage Hàng nhật: <a href="https://www.facebook.com/HangChuanNhatMaiPhuongTokyo" target="blank">Page Hàng Nhật >> click</a> </h4>
      <h4 style="color: blue;white-space:pre-line">Zalo: (+81)9029111390 </h4>
      <h4 style="color: red;white-space:pre-line"> Email: maiphuong.tokyo@gmail.com </h4>
    </div>
</div>
</template>

<script>


export default {
    name: 'HuongDanGuiHang',
    data(){ 
        return{
            huongDanYamato: "https://i.pinimg.com/originals/6f/c0/b9/6fc0b99daab5a630959c792720ef5353.jpg",
            huongDanBuuDien: "https://i.pinimg.com/originals/97/28/69/97286953e47bc9d2d077e3215c4cad8e.jpg",

            

     }
    },
}
</script>
<style scoped>
.HuongDanGuiHang{
    margin-top: 160px;
    margin-left: 30px;
    margin-right: 30px;
}
.yamato{
    text-align: center;
    
}
.japanpost{
    text-align: center;
    
}
.thong-tin{
  border-radius: 25px 0px 0px 25px;
  background-color: #34baeb;
  color: white;
  padding-top: 10px;
  padding-bottom: 4px;
  margin-bottom: 1em;
  margin-top: 1em;
  text-align: left !important;
}
</style>